<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="6">
        <v-list dense>
          <v-subheader>{{ $t("home.last-size") }}</v-subheader>
          <v-list-item
            v-for="(size, index) in sizes"
            :key="index"
          >
            <v-list-item-title>{{ size.width + " x " + size.height + " px" }}</v-list-item-title>
            <v-list-item-action>
              <v-btn
                small
                icon
                @click="removeDimension(size)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="6">
        <v-list dense>
          <v-subheader>{{ $t("home.recent") }}</v-subheader>
          <v-list-item
            v-for="(project, index) in projects"
            :key="index"
          >
            <v-list-item-title>{{ project.name }}</v-list-item-title>
            <v-list-item-action>
              <v-btn
                small
                icon
                @click="removeProject(project)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileFavouriteConnector } from "../Database/ProfileFavouriteConnector.js";

// Tools
const pathInfo = require("path");

export default {
  components: {},
  data() {
    return {
      profileFavouriteConnector: new ProfileFavouriteConnector(this.$store.state.user),
      sizes: [],
      projects: [],
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getHistDimensions();
      this.getHistProjects();
    }
  },
  methods: {
    getHistDimensions() {
      this.profileFavouriteConnector
        .getHistDimensions()
        .then((data) => {
          this.sizes = data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getHistProjects() {
      this.profileFavouriteConnector
        .getHistProjects(11)
        .then((listProjects) => {
          // TODO: format in db server
          this.projects = listProjects.map((project) => {
            return {
              pid: project.proj_id,
              name: pathInfo.basename(project.path, ".zip"),
            };
          });
        })
        .catch((err) => {
          this.$store.dispatch("openSnackbar", {
            title: this.$t("dialog.warning"),
            txt: this.$t("error.delete"),
            colorBg: "red",
          });
          console.error(err);
        });
    },
    removeDimension(size) {
      this.profileFavouriteConnector
        .deleteHistDimension(size.width, size.height)
        .then(() => {
          // remove element from array
          this.sizes = this.sizes.filter((data) => {
            return data !== size;
          });
        })
        .catch((err) => {
          this.$store.dispatch("openSnackbar", {
            title: this.$t("dialog.warning"),
            txt: this.$t("error.delete"),
            colorBg: "red",
          });
          console.error(err);
        });
    },
    removeProject(project) {
      this.profileFavouriteConnector
        .deleteHistProject(project.pid)
        .then(() => {
          // remove element from array
          this.projects = this.projects.filter((data) => {
            return data !== project;
          });
        })
        .catch((err) => {
          this.$store.dispatch("openSnackbar", {
            title: this.$t("dialog.warning"),
            txt: this.$t("error.delete"),
            colorBg: "red",
          });
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
